import React, {useState, useEffect} from 'react';
import {CircularProgress, Menu, MenuItem, Box, Grid, Typography, ListItem, ListItemText, Button, Skeleton} from "@mui/material";
import BackButton from "../../common/back-button";
import useWidth from "../../../hooks/useWidth";
import moment from "moment";
import DownloadIcon from '@mui/icons-material/Download';
import useReportLogs from '../../../hooks/useReportLogs';

const ReportLogsDetailViewComponent = () => {

    const breakpoints = useWidth();
    const {reportLogsData, isFetchingLogDetails, viewReportLogs, isDownloadingReport, downloadAsReport} = useReportLogs();
    console.log("Mayee reportLogsData", reportLogsData);

    let reportId = new URLSearchParams(window.location.search).get("reportId");

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    useEffect(() => {
        viewReportLogs(reportId);
    }, [])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const downloadFile = ( reportId, reportName, format) => {
        handleClose();
        downloadAsReport(reportId, reportName, format);
    }

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{color: "#58565f", fontWeight: 600, fontSize: 20}}>
                        Report Logs Detail View
                    </Typography>
                </Grid>
            </Grid>

            <Box sx={{mt: 3}}>
                <Grid container>
                    <Grid item={3}>
                        <BackButton />
                    </Grid>

                    {reportLogsData?.report_status == "Completed" && 
                        <Grid item={9} sx={{ml: "auto"}}>
                            <>
                                <Button 
                                    variant="contained" 
                                    startIcon= {isDownloadingReport ? <CircularProgress sx={{color: "#fff", mt: "-2px"}} size={11} /> : <DownloadIcon sx={{height: 18}} />}
                                    sx={{
                                        width: (breakpoints == "xs" || breakpoints == "sm") ? {} : {}, 
                                        mt: "6px", height: "33px", textTransform: "none", backgroundColor: "#5959D8",
                                        color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}
                                    }}
                                    id="basic-button"
                                    aria-controls={(open) ? "basic-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={(open) ? "true" : undefined}
                                    onClick={handleClick}

                                >
                                    Download As
                                </Button>

                                <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    MenuListProps={{'aria-labelledby': 'basic-button'}}
                                    anchorOrigin={{
                                        vertical: "bottom", 
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top", 
                                        horizontal: "right",
                                    }}
                                    sx={{
                                        "& .MuiPaper-root": {
                                        width: "140px",
                                        },
                                    }}
                                >
                                    <MenuItem onClick={(e) => downloadFile(reportLogsData?.report_id, reportLogsData?.report_type, "pdf")}>PDF</MenuItem>
                                    <MenuItem onClick={(e) => downloadFile(reportLogsData?.report_id, reportLogsData?.report_type, "csv")}>CSV</MenuItem>
                                    <MenuItem onClick={(e) => downloadFile(reportLogsData?.report_id, reportLogsData?.report_type, "excel")}>Excel</MenuItem>
                                </Menu>
                            </>
                        </Grid>
                    }
                </Grid>
                
                <Box sx={{backgroundColor: "#fff", borderRadius: "8px", padding: 2, mt: 2}}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container sx={{padding: "0px 20px 0px 0px"}}>
                                <Grid item xs={6}>
                                    <ListItem sx={{pt: "2px", pb: "2px"}}>
                                        <ListItemText sx={{display: "flex"}}
                                            primary={
                                                <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                                    Report ID: &nbsp;
                                                </Typography>
                                            } 
                                            secondary={(isFetchingLogDetails) ?
                                                    <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd"}} />
                                                :
                                                    <Typography sx={{color: "#58565f", fontSize: 14}}>
                                                        {reportLogsData?.report_id}
                                                    </Typography>
                                            }
                                        />
                                    </ListItem>
                                </Grid>
                            </Grid>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Report Type: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {reportLogsData?.report_type}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Generated By: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {reportLogsData?.generated_by}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{ display: "flex"}}
                                    primary={
                                        <Typography sx={{ color: "#58565f", fontSize: 14, fontWeight: "bold" }}>
                                            Generated Date: &nbsp;
                                        </Typography>
                                    }
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {moment(reportLogsData?.timestamp).format("MMMM DD, YYYY HH:mmA")}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Date Range Start: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {moment(reportLogsData?.date_range_start).format("MMMM DD, YYYY HH:mmA")}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Date Range End: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {moment(reportLogsData?.date_range_end).format("MMMM DD, YYYY HH:mmA")}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{ display: "flex"}}
                                    primary={
                                        <Typography sx={{ color: "#58565f", fontSize: 14, fontWeight: "bold" }}>
                                            Result Path URL: &nbsp;
                                        </Typography>
                                    }
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "400px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: (reportLogsData?.result_path_url) ? "#5959D8" : "#58565f", fontSize: 14}}>                                         
                                            {(reportLogsData?.result_path_url) ? reportLogsData?.result_path_url : "N / A"}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{ display: "flex"}}
                                    primary={
                                        <Typography sx={{ color: "#58565f", fontSize: 14, fontWeight: "bold" }}>
                                            Status: &nbsp;
                                        </Typography>
                                    }
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "450px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{fontSize: 14, color:
                                            (reportLogsData?.report_status === "Completed") ? "#40BF7E" 
                                            : 
                                                (reportLogsData?.report_status === "Ongoing") ? "#FFA500" 
                                            :  
                                                (reportLogsData?.report_status === "Error") ? "#E76C59" 
                                            : 
                                                null
                                        }}>
                                            {reportLogsData?.report_status}
                                        </Typography>
                                    }
                                />
                            </ListItem>

                            <ListItem sx={{pt: "4px", pb: "6px"}}>
                                <ListItemText sx={{display: "flex"}}
                                    primary={
                                        <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                            Remarks: &nbsp;
                                        </Typography>
                                    } 
                                    secondary={(isFetchingLogDetails) ?
                                        <Skeleton variant="text" sx={{fontSize: 14, width: "420px", backgroundColor: "#d8d8fdbd"}} />
                                    :
                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                            {(reportLogsData?.remarks) ? reportLogsData?.remarks : "N / A"}
                                        </Typography>
                                    }
                                />
                            </ListItem>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}

export default ReportLogsDetailViewComponent